module.exports = __webpack_public_path__ + "images/8_NOON_Switches.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/8_NOON_Switches.png
// module id = 265
// module chunks = 0